import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { isEUNonBusinessStore } from 'ggApp/modules/store';

import { Item } from './Item';

const enhance = compose(
    connect(
        createStructuredSelector({
            isEUNonBusinessStore,
        }),
    ),
);

export default enhance(Item);
